<template>
  <a-card>
    <div slot="title">
      <h4 class="margin-remove">MANIFEST ACCOUNT PAY</h4>
      <small>{{
        datasource.data_header ? datasource.data_header.no_ap : "-"
      }}</small>
    </div>
    <a-row :gutter="24">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Date Of AP</span>
            <span class="m-list-desc">{{
              moment(
                datasource.data_header ? datasource.data_header.tgl_buat : null
              ).format(getDefaultDateFormat)
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>No. PO/WO/Adendum</span>
            <span class="m-list-desc">{{
              datasource.data_header ? datasource.data_header.no_transaksi : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Supplier</span>
            <span class="m-list-desc">{{
              datasource.data_header
                ? datasource.data_header.nama_supplier
                : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Nama Bank/No.Rekening</span>
            <span class="m-list-desc">{{
              `${
                datasource.data_header ? datasource.data_header.bank : "-"
              } / ${
                datasource.data_header
                  ? datasource.data_header.no_rekening
                  : "-"
              }`
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>No. Invoice</span>
            <span class="m-list-desc">{{
              datasource.data_header ? datasource.data_header.no_invoice : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Date Of Invoice</span>
            <span class="m-list-desc">{{
              moment(
                datasource.data_header
                  ? datasource.data_header.tgl_invoice
                  : null
              ).format(getDefaultDateFormat)
            }}</span>
          </li>
          <li>
            <span class="m-list-title">{{
              `Due Date(${dueDays >= 0 ? dueDays : 0} day/s)`
            }}</span>
            <span class="m-list-desc">{{
              moment(
                datasource.data_header ? datasource.data_header.due_date : null
              ).format(getDefaultDateFormat)
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Description</span>
            <span class="m-list-desc">{{
              datasource.data_header ? datasource.data_header.description : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Note</span>
            <span class="m-list-desc">{{
              datasource.data_header ? datasource.data_header.catatan : "-"
            }}</span>
          </li>
          <li class="m-display-flex space-between align-middle">
            <span class="m-list-title" for>File Document</span>
            <span class="m-list-desc">
              <a-button icon="eye" @click="handleViewDoc()">
                {{getScreen ? '' : 'View Document'}}
              </a-button>
            </span>
          </li>
        </ul>
        <a-list
          bordered
          :data-source="datasource.data_dtl"
          class="margin-bottom margin-top"
        >
          <a-list-item
            slot="renderItem"
            slot-scope="item, index"
            class="m-display-flex space-between align-middle"
          >
            {{
              item.item_name == null
                ? "Sub Total"
                : item.prosentase
                ? item.item_name + " (" + item.prosentase + "%)"
                : item.item_name
            }}
            <h4>
              {{ item.kategori == "5" ? "-" : ""
              }}{{
                formatCurrency(datasource.data_header.mata_uang, item.harga)
              }}
            </h4>
          </a-list-item>
          <div slot="header">
            <h3>DETAIL</h3>
          </div>
          <div slot="footer" class="m-display-flex space-between align-middle">
            <h3>GRAND TOTAL</h3>
            <h4>
              {{
                formatCurrency(
                  datasource.data_header
                    ? datasource.data_header.mata_uang
                    : "",
                  datasource.data_header ? datasource.data_header.value : 0
                )
              }}
            </h4>
          </div>
        </a-list>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card title="Status">
          <template slot="extra">
            <a-tag color="green">Created</a-tag>
          </template>
          <h4 class="margin-remove">
            {{
              `Pembuat - ${
                datasource.data_header ? datasource.data_header.tlc_create : "-"
              }`
            }}
          </h4>
          <!--          <small>{{ datasource.data_header.create_dt }}</small>-->
          <small>{{
            moment(
              datasource.data_header ? datasource.data_header.create_dt : null
            ).format(getDateTimeFormat)
          }}</small>
        </a-card>
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Related Document</h4>
            </div>
            <a-list
              itemLayout="horizontal"
              :dataSource="datasource.data_dokumen_terkait"
            >
              <Empty
                v-if="
                  datasource.data_dokumen_terkait
                    ? datasource.data_dokumen_terkait.length <= 0
                    : datasource.data_dokumen_terkait
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div
                    slot="title"
                    class="m-display-flex flex-column align-top"
                  >
                    <Status
                      :class="!getScreen ? 'margin-remove' : ''"
                      :status="item.status"
                    />
                    <a @click="handleDocument(item)"
                      >{{ item.header }} | {{ item.tlc }}</a
                    >
                  </div>
                  <template slot="description">
                    <span>{{ item.no_manifest }}</span>
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import dueDateCalc from "@/mixins/dueDateCalc.js";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "manifest-ap",
  component: { Status },
  data() {
    return { datasource: {}, dueDays: 0 };
  },
  mixins: [dueDateCalc, HandleRoute, CurrencyFormat],
  created() {
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
    ]),
  },
  methods: {
    moment,
    fetch() {
      this.$store
        .dispatch("getManifest", { id: this.$attrs.id })
        .then((res) => {
          this.datasource = res;
          this.datasource.data_header = res.data_header[0];
          this.dueDays = this.dateCalculation(
            this.datasource.data_header.due_date
          );
        });
    },
    handleDocument(item) {
      const data = {
        rest_api: item.rest_api.toLowerCase(),
        id_manifest: item.id_manifest,
        tlc: this.getAuth.username,
        user_pembuat: item.user_pembuat,
      };
      this.handleView(data);
    },
    handleViewDoc() {
      window.open(this.$serviceUrl + this.datasource.data_header.link);
    },
  },
};
</script>

<style></style>
